import React from 'react';
import { useSelector } from 'react-redux';
import styles from '../details-table.module.scss';

export const CustomHeader = (props) => {
    const { userSort } = useSelector((s) => s.users);
    const { productGateSort } = useSelector((s) => s.productGate);
    const { rightSort } = useSelector((s) => s.rights);
    const { productSort } = useSelector((s) => s.products);
    const { readyProductSort } = useSelector((s) => s.readyProducts);
    const { dateMathSort } = useSelector((s) => s.dateMath);
    const { sortParam: dateMathCalculationSort } = useSelector(
        (s) => s.dateMathCalculations,
    );
    const { pmxDeliveriesSort } = useSelector((s) => s.pmxDeliveries);
    const { jobSort } = useSelector((s) => s.jobs);
    const { sortParam: jobMetricsSort } = useSelector(
        (state) => state.jobMetrics,
    );

    const { colId, page, displayName, setSort } = props;


    // Map page to sort state
    const sortMap = {
        users: userSort,
        productUpdates: productGateSort,
        rights: rightSort,
        products: productSort,
        dateMath: dateMathSort,
        dateMathCalculations: dateMathCalculationSort,
        pmxDeliveries: pmxDeliveriesSort,
        jobs: jobSort,
        jobMetrics: jobMetricsSort,
        readyProducts: readyProductSort,
    };


    let sortState = sortMap[page];
    if (Array.isArray(sortState)) {
        sortState = sortState.join(',');
    }
    if (typeof sortState === 'string') {
        sortState = sortState.split(',');
    } else if (!Array.isArray(sortState)) {
        sortState = [];
    }

    const sortedColId = sortState[0];
    const sortDirection = (sortState[1] || 'asc').toLowerCase();

    const isActive = colId === sortedColId;

    const handleSort = () => {
        if (!isActive) {
            setSort(colId, 'asc');
        } else {
            setSort(colId, sortDirection === 'asc' ? 'desc' : 'asc');
        }
    };


    return (
        <button
            className={`${styles.headerCell} ${isActive ? styles.active : ''}`}
            onClick={handleSort}
            type="button"
        >
            {displayName}
            {isActive ? (sortDirection === 'desc' ? '↓' : '↑') : ''}
        </button>
    );
};
